module.exports = __webpack_public_path__ + "img/30.c67e18a9.png";